import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker-cssmodules.css";

import "./EventUpdate.css";

class EventUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      event: {
        startDate: moment(),
        duration: 0,
        title: '',
        description: '',
        participants :[]
      }
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.updateEvent = this.updateEvent.bind(this);
  }
  componentDidMount() {
    console.log("EventUpdate : componentDidMount(),this.props.startDate",this.props.startDate,typeof this.props.startDate); 
    this.setState({
        event :{
            startDate:moment(this.props.startDate)
        }
    });   
  }
  handleDateChange(date) {
    console.log("EventUpdate : handleDateChange(date)",date,typeof date);  
    this.setState({
        event :{
            startDate: date
        }
      }); 
  }
  handleClose() {
    console.log("EventUpdate : handleClose()");
    this.props.onClose();
    this.setState({ redirect: true });
  }
  updateEvent() {
    this.setState({
      event: {
        duration: this.inputSelectDuration.value || 0,
        title: this.eventNameInput.value || 'noName',
        description: this.eventDescrInput.value || ''
      }
    });
    this.props.onUpdateEvent({
        startDate: this.state.event.startDate,
        duration: this.inputSelectDuration.value || 0,
        title: this.eventNameInput.value || 'noName',
        
      description: this.eventDescrInput.value || '',
        participants : this.props.event.participants
      });
    this.handleClose();
  }
  render() {
    return this.state.redirect ? (
      <Redirect to="/" />
    ) : (
      <div className="modal is-active">
        <div onClick={this.handleClose} className="modal-background"></div>
        <div className="modal-content">
          <div className="box add-new-event-container ">
          <div>
            <h2>Termin/Event ändern</h2>


            <div className="field">
            <label className="label">Name des Termins:</label>
            <div className="control has-icons-left has-icons-right">
              <input className="input is-success" type="text" placeholder="" name="eventName" ref={input => {
                  this.eventNameInput = input;
                }} defaultValue={this.props.event.title}/>
              <span className="icon is-small is-left">
                  <ion-icon name="calendar"></ion-icon>
              </span>
              <span className="icon is-small is-right">
              <ion-icon name="checkmark"></ion-icon>
              </span>
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Datum &amp; Uhrzeit: </label>
            <DatePicker
              selected={this.state.event.startDate}
              onChange={this.handleDateChange}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="LLL"
              timeCaption="Zeit:"
            />
          </div>
          </div>
          <div className="field">
          <label className="label">Dauer:</label>
          <div className="control">
          <div className="select">
            <select
              name="duration"
              id="duration"
              ref={select => {
                this.inputSelectDuration = select;
              }}
            defaultValue={this.props.event.duration}
            >
              <option value="1">1 Stunde</option>
              <option value="1.5">1.5 Stunden</option>
              <option value="2">2 Stunden</option>
              <option value="2.5">2.5 Stunden</option>
              <option value="3">3 Stunden</option>
              <option value="3.5">3.5 Stunden</option>
              <option value="4">4 Stunden</option>
              <option value="4.5">4.5 Stunden</option>
              <option value="5">5 Stunden</option>
              <option value="5.5">5.5 Stunden</option>
              <option value="6">6 Stunden</option>
            </select>

            ^
            </div> 
          </div>
          </div>
          <div className="field">
          <div className="control">
            <label className="label">Beschreibung:</label>
            <textarea
              className="textarea" 
              type="text"
              name="eventDescr"
              defaultValue={this.props.event.description}
              ref={inputTextArea => {
                this.eventDescrInput = inputTextArea;
              }}
            />
          </div>
          </div>

          <div className="field is-grouped">
            <div className="control">
              <button className="button is-primary" onClick={this.updateEvent}>SPEICHERN</button>
            </div>
            <div className="control">
            <button className="button is-text is-outlined has-margin-left"  onClick={this.handleClose}>Abbrechen</button>
            </div>
          </div>

         
          
          </div>
        </div>
      </div>
    );
  }
}

export default EventUpdate;
4


// WEBPACK FOOTER //
// ./src/EventUpdate.js